import BreakpointPlaceholder from "./BreakpointPlaceholder";

export default BreakpointPlaceholder;
